export class Database {
  constructor(
    public name:string) {}
}
